/**
     * HeaderChanged.contract.ts — Event Contract System™ (generation v1).
     * Reserved: declared for future shell/header flows; no production publisher or subscriber yet.
     */

    import type { EventContract } from '../EventContractRegistry';

    export const HeaderChangedContract: EventContract = {
      name: 'HeaderChanged',
      version: 1,
      description: "Reserved: declared for future shell/header flows; no production publisher or subscriber yet.",
      publishers: [],
      subscribers: [],
      fields: [
        { name: 'header', type: 'string', required: true, description: "New header label" },
      ],
      allowExtraFields: true,
      timestampPolicy: "Publish time (Date.now()) when the header changes.",
      stability: 'reserved',
      deprecated: false,
      example: null,
    };
    